import slices from './slices';

export default {
    ...slices.unregisteredUsersSlice.actions,
}